import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
  Button,
  Form,
  FormFeedback,
  Alert,
  Spinner,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import logoLight from "../../assets/images/Logo-with.png";
import languages from '../../common/languages';

import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
import { get, map } from "lodash";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { loginUser, socialLogin, resetLoginFlag } from "../../slices/thunks";

import { createSelector } from "reselect";
import { useTranslation } from "react-i18next";
import { updateTranslations } from "../../i18n";
//import images

const Login = (props) => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();


  const selectLayoutState = (state) => state;
  const loginpageData = createSelector(selectLayoutState, (state) => ({
    user: state.Account.user,
    error: state.Login.error,
    loading: state.Login.loading,
    errorMsg: state.Login.errorMsg,
  }));

  // Inside your component
  const { user, error, loading, errorMsg } = useSelector(loginpageData);
  
  const [userLogin, setUserLogin] = useState([]);
  const [passwordShow, setPasswordShow] = useState(false);
  const [selectedLang, setSelectedLang] = useState("");
  const [isLanguageDropdown, setIsLanguageDropdown] = useState(false);


  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: userLogin.email,
      password: userLogin.password,
    },
    validationSchema: Yup.object({
      email: Yup.string().email(t("Invalid email format")).required(t("Email is required")),
      password: Yup.string().required(t("Password is required")),
    }),
    onSubmit: (values) => {
      dispatch(loginUser(values, props.router.navigate));
    },
  });

  const signIn = (type) => {
    dispatch(socialLogin(type, props.router.navigate));
  };

  //handleTwitterLoginResponse
  // const twitterResponse = e => {}

  //for facebook and google authentication
  const socialResponse = (type) => {
    signIn(type);
  };

  const toggleLanguageDropdown = () => {
    setIsLanguageDropdown(!isLanguageDropdown);
  };

  const changeLanguageAction = async (lang) => {
    localStorage.setItem("I18N_LANGUAGE", lang);
    localStorage.setItem("langId", lang === 'en'? 1 : 2)
    await updateTranslations(lang); 
    setSelectedLang(lang);
    window.location.reload();

    setTimeout(() => {
      validation.validateForm();
    }, 100);
  };
  
  useEffect(() => {
    const currentLang = localStorage.getItem("I18N_LANGUAGE") || "ar";
    updateTranslations(currentLang);
  }, []);
  

  useEffect(() => {
    if (errorMsg) {
      setTimeout(() => {
        dispatch(resetLoginFlag());
      }, 3000);
    }
  }, [dispatch, errorMsg]);

  
  useEffect(() => {
    const currentLanguage = localStorage.getItem("I18N_LANGUAGE");
    setSelectedLang(!currentLanguage ? 'en' : currentLanguage);
  }, []);

  useEffect(() => {
    if (user && user) {
      const updatedUserData =
        process.env.REACT_APP_DEFAULTAUTH === "firebase"
          ? user.multiFactor.user.email
          : user.email;
      const updatedUserPassword =
        process.env.REACT_APP_DEFAULTAUTH === "firebase"
          ? ""
          : user.confirm_password;
      setUserLogin({
        email: updatedUserData,
        password: updatedUserPassword,
      });
    }
  }, [user]);

  document.title = "Alitqan | Login" ;

  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="auth-page-content mt-lg-5">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="text-center mt-sm-5 mb-4 text-white-50">
                  <div>
                    <Link to="/" className="d-inline-block auth-logo">
                      <img src={logoLight} alt="" height="50" />
                    </Link>
                  </div>
                  {/* <p className="mt-3 fs-15 fw-medium">Premium Admin & Dashboard Template</p> */}
                </div>
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="mt-4 card-bg-fill">
                  <CardBody className="p-4">
                    <div className="text-center mt-2">
                      <h5 className="text-primary">{t("welcomeBack")}</h5>
                      <p className="text-muted">
                        {t("welcomeTitle")}
                      </p>
                    </div>
                    {error && error ? (
                      <Alert color="danger"> {t(error)} </Alert>
                    ) : null}
                    <div className="p-2 mt-4">
                    <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                        action="#"
                        dir={i18n.language === "ar" ? "rtl" : "ltr"}
                      >
                        <div className="mb-3">
                          <Label htmlFor="email" className="form-label">
                            {t("Email")}
                          </Label>
                          <Input
                            name="email"
                            className="form-control"
                            placeholder={t("enterEmail")}
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.email || ""}
                            invalid={
                              validation.touched.email && validation.errors.email ? true : false
                            }
                          />
                          {validation.touched.email && validation.errors.email ? (
                            <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-3">
                          <div
                            className={
                              i18n.language === "ar" ? "float-start text-start" : "float-end text-end"
                            }
                          >
                            <Link to="/forgot-password" className="text-muted">
                              {t("ForgotPassword")}
                            </Link>
                          </div>
                          <Label className="form-label" htmlFor="password-input">
                            {t("Password")}
                          </Label>
                          <div className="position-relative auth-pass-inputgroup mb-3">
                            <Input
                              name="password"
                              value={validation.values.password || ""}
                              type={passwordShow ? "text" : "password"}
                              className="form-control"
                              placeholder={t("enterPassword")}
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              invalid={
                                validation.touched.password && validation.errors.password
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.password && validation.errors.password ? (
                              <FormFeedback type="invalid">
                                {validation.errors.password}
                              </FormFeedback>
                            ) : null}
                            <button
                              className={`btn btn-link position-absolute ${
                                i18n.language === "ar" ? "start-0" : "end-0"
                              } top-0 text-decoration-none text-muted material-shadow-none`}
                              type="button"
                              id="password-addon"
                              onClick={() => setPasswordShow(!passwordShow)}
                            >
                              <i className="ri-eye-fill align-middle"></i>
                            </button>
                          </div>
                        </div>

                        {/* <div className="form-check mb-3">
                          <div
                            className="d-flex align-items-center"
                            style={{
                              direction: i18n.language === "ar" ? "rtl" : "ltr",
                            }}
                          >
                            <Input
                              type="checkbox"
                              id="auth-remember-check"
                              className="form-check-input"
                              style={{
                                marginInlineEnd: "8px",
                              }}
                            />
                            <Label htmlFor="auth-remember-check" className="mb-0">
                              {t("RememberMe")}
                            </Label>
                          </div>
                        </div> */}
                        <div className="mt-4">
                          <Button
                            color="success"
                            disabled={error ? null : loading ? true : false}
                            className="btn btn-success w-100"
                            type="submit"
                          >
                            {loading ? (
                              <Spinner size="sm" className="me-2 ms-2">
                                {" "}
                                Loading...{" "}
                              </Spinner>
                            ) : null}
                            {t("signIn")}
                          </Button>
                        </div>
                      </Form>
                    </div>
                    <div className="d-flex justify-content-center align-items-center position-relative">
                    <Dropdown
                        isOpen={isLanguageDropdown}
                        toggle={toggleLanguageDropdown}
                        className={`ms-1 topbar-head-dropdown header-item ${
                          i18n.language === "ar" ? "dropdown-rtl" : ""
                        }`}
                      >
                        <span className="me-2">{t("Language")}</span>
                        <DropdownToggle
                          className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                          tag="button"
                        >
                          <img
                            src={get(languages, `${selectedLang}.flag`)}
                            alt="Header Language"
                            height="20"
                            className="rounded"
                          />
                        </DropdownToggle>

                        <DropdownMenu className={`notify-item language py-2 ${i18n.language === "ar" ? "text-end" : "text-start"}`}>
                          {map(Object.keys(languages), (key) => (
                            <DropdownItem
                              key={key}
                              onClick={() => changeLanguageAction(key)}
                              className={`notify-item d-flex align-items-center ${
                                selectedLang === key ? "active" : "none"
                              }`}
                              style={{ direction: i18n.language === "ar" ? "rtl" : "ltr" }}
                            >
                              <img
                                src={get(languages, `${key}.flag`)}
                                alt="flag"
                                className={i18n.language === "ar" ? "ms-2 rounded" : "me-2 rounded"}
                                height="18"
                              />
                              <span className="align-middle">
                                {t(get(languages, `${key}.label`))}
                              </span>
                            </DropdownItem>
                          ))}
                        </DropdownMenu>
                      </Dropdown>

                    </div>
                  </CardBody>
                </Card>

                {/* <div className="mt-4 text-center">
                  <p className="mb-0">
                    Don't have an account ?{" "}
                    <Link
                      to="/register"
                      className="fw-semibold text-primary text-decoration-underline"
                    >
                      {" "}
                      Signup{" "}
                    </Link>{" "}
                  </p>
                </div> */}
              </Col>
            </Row>
          </Container>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default withRouter(Login);
